import React, { useState, useEffect } from "react";
import { Table, Input, Button, Space, Tag, Select, Card } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { SearchOutlined, DollarOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { fetchAllBatches, 
        fetchParentBatch,
        fetchStudentBatch
 } from "../../store/batchSlice";
import {
  fetchFeeStructuresByBatch,
  fetchPaymentInformation,
  fetchPaymentByTermAndStudent,
} from "../../store/createPaymentSlice.js";
import { fetchStudentsByBatch } from "../../store/studentsSlice.js";
import { fetchTerms } from "../../store/termSlice";
import useTokenExpiryCheck from "../../utils/UseTokenExpiryCheck";

const { Option } = Select;

const CreatePayment = () => {
  const dispatch = useDispatch();
  //global informantion
  const { batches = [] } = useSelector((state) => state.batches);
  const { terms } = useSelector((state) => state.terms);
  const { batch_students } = useSelector((state) => state.students);
  const { studentPayment,     studentPaymentByTermAndStudent = [],                 // for student role
 } = useSelector((state) => state.payments);
  const { isAuthenticated } = useSelector((state) => state.auth);
   //Local state management
  const [parentsBatch, setParentsBatch] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [selectedTerm, setSelectedTerm] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [selectedStudentPayment, setSelectedStudentPayment] = useState("");
  const [sortedBatches, setSortedBatches] = useState([]);
  const [userRole, setUserRole] = useState(null);
 const [studentId, setStudentId] = useState(null);
 // pull roles & studentIds from session
   const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
   const roles   = userInfo.roles || [];
   const allowedStudentIds =
     (roles.includes("Parent") || roles.includes("Student"))
       ? userInfo.studentIds || []
       : null;
 


  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const navigate = useNavigate();

  useTokenExpiryCheck();
  //Use effect 1: fetch batch and term
  useEffect(() => {
    if (isAuthenticated) {
      const userInfoString = localStorage.getItem("userInfo");
      const userInfo = userInfoString ? JSON.parse(userInfoString) : {}; // Parse if
      console.log("roles", roles);
      console.log("userInfo", userInfo);
      const userId = userInfo?.userId || [];
      console.log("userId", userId);

  if (roles.includes("Student")) {
    setUserRole("Student");
    // pick their first (and only) studentId
    setStudentId( Array.isArray(userInfo.studentIds) ? userInfo.studentIds[0] : null );
    // fire your student‐specific batch fetch
    dispatch(fetchStudentBatch(userInfo.userId));
  }
      if (roles.includes("Parent")) {
        dispatch(fetchParentBatch(userId));
      } else if (roles.includes("Student")) {
        dispatch(fetchStudentBatch(userId));
      } else {
        dispatch(fetchAllBatches());
      }
      dispatch(fetchTerms());
    }
  }, [dispatch, isAuthenticated]);
  
 //UseEffect 2: fetch students of the selected batch (batch_students)
  useEffect(() => {
    if (selectedBatch) {
      console.log("selectedBatch", selectedBatch);
      dispatch(fetchStudentsByBatch(selectedBatch));
    }
  }, [selectedBatch, dispatch]);

  useEffect(() => {
    if (Array.isArray(batches)) {
      setSortedBatches(
        [...batches].sort((a, b) => a.batchName.localeCompare(b.batchName))
      );
    }
  }, [batches]);
  //UseEffect 3: fetch the fee strucutres of the selected batch of students in the selected term (batch_term_feeStructures)
  useEffect(() => {
    if (selectedBatch && selectedTerm.termId && userRole !== "Student") {
      dispatch(
        fetchFeeStructuresByBatch({
          termId: selectedTerm.termId,
          batchId: selectedBatch,
        })
      );
    }
  }, [dispatch, selectedBatch, selectedTerm]);


    // 4) If Student: whenever term changes, fetch their payment history
 useEffect(() => {
   if (userRole === "Student" && studentId && selectedTerm.termId) {
     dispatch(
       fetchPaymentByTermAndStudent({
         termId: selectedTerm.termId,
         studentId,
       })
     );
   }
 }, [dispatch, userRole, studentId, selectedTerm.termId]);

  //UseEffect 4: fetch all payment informations of the specified batch and term (studentPayment)
  useEffect(() => {
    if (selectedTerm && selectedBatch) {
      const batchId = selectedBatch;
      const termId = selectedTerm.termId;
      dispatch(fetchPaymentInformation({ batchId, termId }));
    }
  }, [dispatch, selectedTerm, selectedBatch]);

  //Use effect 5: based on the selected students, student total payment information and the selected term, collect  details of student payment and set to batchStudentsWithPaymentInfo.
 
  useEffect(() => {
    if (isAuthenticated && studentPayment && studentPayment.length > 0) {
      const userInfoString = localStorage.getItem("userInfo");
      const userInfo = userInfoString ? JSON.parse(userInfoString) : {}; // Parse if

      console.log("userInfo", userInfo);
      const roles = userInfo?.roles || [];
      console.log("roles", roles);
      const studentIds = userInfo?.studentIds || [];
      console.log("studentIds", studentIds);
      const studentIdSet = new Set(studentIds);

      const filteredPayments = studentPayment?.filter((payment) =>
        studentIdSet?.has(payment.studentId)
      );
      setSelectedStudentPayment(filteredPayments);
    }
  }, [dispatch, studentPayment, isAuthenticated]);

 
  //Function 1: based on the selected termId, set selectedTerm with property termId and ternname
// term change handler: for Students we immediately fetch their payment
const handleTermChange = (value) => {
  const term = terms.find((t) => t.termId === value) || {};
  setSelectedTerm({ termId: value, termName: `${term.name||""} ${term.academicYear||""}` });

  if (userRole === "Student" && studentId) {
    dispatch(fetchPaymentByTermAndStudent({ termId: value, studentId }));
  }
};


 
 // 1) Normalize “rawData” into an array
 //
 const rawData = userRole === "Student"
   ? studentPaymentByTermAndStudent    // might be a single object or array
   : selectedStudentPayment;           // always array for parent/admin

 const arr = Array.isArray(rawData)
   ? rawData
   : rawData && typeof rawData === "object"
     ? [rawData]
     : [];

 //
 // 2) Rename fields so your columns (which expect
 //    `termId`, `studentIdno`, etc.) actually find them
 //
 const standardized = arr.map(item => ({
   ...item,
   termId: item.termId || item.termID,
   studentIdno: item.studentIdno || item.studentIdno,  // already matches
   // any other mappings if needed…
 }));

 //
 // 3) Filter by allowedStudentIds for Parent/Student
 //
 const finalData = Array.isArray(allowedStudentIds)
   ? standardized.filter(r => allowedStudentIds.includes(r.studentId))
   : standardized;
 

 
  //Function 2: table column definition
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
  });

  //Function 3:
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  //Function 4:
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  //Function 5:
  const getFullNameSearchProps = () => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="Search full name"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small">
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      const fullName = `${record.firstName || ""} ${record.surName || ""} ${
        record.lastName || ""
      }`.toLowerCase();
      return fullName.includes(value.toLowerCase());
    },
  });

  //Function 6:
  const handlePaymentClick = (record) => {
    console.log("record", record);
     navigate("/make-payment", {
      state: {
        studentData: {
          studentId: record.studentId,
          batchId: selectedBatch,
          studentIdno: record.studentIdno,
          fullName: `${record.firstName || ""} ${record.surName || ""} ${
            record.lastName || ""
          }`,
          sectionName: record.sectionName,
          payableAmount: record.payableAmount,
          paidAmount: record.paidAmount,
          unpaidAmount: record.unpaidAmount,
          termID: record.termID,
        },
      },
    });
  };

  //Function 7:
  const handlePaymentViewClick = (record) => {
    navigate("/view-payment", {
      state: {
        studentData: {
          studentId: record.studentId,
          studentIdno: record.studentIdno,
          fullName: `${record.firstName || ""} ${record.surName || ""} ${
            record.lastName || ""
          }`,
          sectionName: record.sectionName,
          payableAmount: record.payableAmount,
          paidAmount: record.paidAmount,
          unpaidAmount: record.unpaidAmount,
          termID: record.termID,
        },
      },
    });
  };
  //Function 8:
  const handleApprovalClick = (record) => {
    console.log("record", record);
    //       navigate("/upload-room-section-mapping");
    navigate("/payment/approve-payment", {
      state: {
        studentData: {
          studentId: record.studentId,
          batchId: selectedBatch,
          studentIdno: record.studentIdno,
          fullName: `${record.firstName || ""} ${record.surName || ""} ${
            record.lastName || ""
          }`,
          sectionName: record.sectionName,
          payableAmount: record.payableAmount,
          paidAmount: record.paidAmount,
          unpaidAmount: record.unpaidAmount,
          termID: record.termID,
        },
      },
    });
  };
  const columns = [
    {
      title: "Student ID",
      dataIndex: "studentIdno",
      key: "studentIdno",
      ...getColumnSearchProps("studentIdno"),
    },
    {
      title: "Full Name",
      key: "fullName",
      render: (_, record) => {
        return `${record.firstName || ""} ${record.surName || ""} ${
          record.lastName || ""
        }`;
      },
      ...getFullNameSearchProps(),
    },
    {
      title: "Payment Term",
      dataIndex: "termId",
      key: "termId",
      render: (_, record) => {
        const term = terms.find((term) => term.termId === record.termId);
 const label = term.name
        ? `${term.name} ${term.academicYear}`
      : "—";
     return <Tag color="blue">{label}</Tag>;      },
    },
    {
      title: "Section",
      dataIndex: "sectionName",
      key: "sectionName",
      render: (_, record) => {
        const student = batch_students.find(
          (student) => student.studentIdno === record.studentIdno
        );
        return student ? `${student.sectionName}` : "";
      },
    },
    {
      title: "payableAmount",
      dataIndex: "payableAmount",
      key: "payableAmount",
    },
    {
      title: "paidAmount",
      dataIndex: "paidAmount",
      key: "paidAmount",
    },
    {
      title: "Unpaid Amount",
      dataIndex: "unpaidAmount",
      key: "unpaidAmount",
      render: (amount) => (
        <span
          style={{
            fontFamily: "monospace",
            color: amount > 0 ? "#ff4d4f" : "#52c41a",
            fontWeight: "bold",
          }}
        >
          ${(amount || 0).toFixed(2)}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        const unpaidAmount = Number(record.unpaidAmount) || 0;
        return (
          <>
            <Button
              type="primary"
              icon={<DollarOutlined />}
              onClick={() => handlePaymentClick(record)}
              disabled={unpaidAmount <= 0}
              style={{
                backgroundColor: unpaidAmount > 0 ? "#1890ff" : undefined,
                borderColor: unpaidAmount > 0 ? "#1890ff" : undefined,
              }}
            >
              Prepare
            </Button>
            <Button
              type="primary"
              icon={<DollarOutlined />}
              onClick={() => handlePaymentViewClick(record)}
              style={{
                backgroundColor: "#F00F77",
                borderColor: "#1890ff",
              }}
            >
              View
            </Button>
          </>
        );
      },
    },
  ];
  //Unused functions

  const handleTableChange = (pagination, filters, sorter) => {
    setPagination(pagination);
  };

    // --- just above your `return ( ... )` ---

  // For Student, drop the "action" column; otherwise keep all columns
 const tableColumns = userRole === "Student"
   ? columns.filter(col => col.key !== "action" && col.key !== "sectionName")
   : columns;
  // Only students get row‑expansion
  const expandable =
    userRole === "Student"
      ? {
        expandedRowRender: record => (
           <div style={{ background: "#fafafa", padding: 16 }}>
             <Space direction="vertical" size="small">
               <Tag color={ record.status === "Paid" ? "green" : "orange" }>
                 Status: {record.status}
               </Tag>
               <Tag color="geekblue">
                 Reference: {record.reference || "—"}
               </Tag>
               <Tag color="gold">
                 Remark: {record.remark || "—"}
               </Tag>
               {record.paymentDocument ? (
                 <Tag color="volcano">
                   <a
                     href={record.paymentDocument}
                     target="_blank"
                     rel="noopener noreferrer"
                   >
                     View Document
                   </a>
                 </Tag>
               ) : (
                 <Tag>Document: —</Tag>
               )}
               <div>
                 <strong>Fee Items:</strong>
                 <Space wrap>
                   {record.feeStructures?.map(f => (
                     <Tag key={f.feeID}>
                       {`${f.feeType}: ${f.amount.toFixed(2)}`}
                     </Tag>
                   )) || <Tag>—</Tag>}
                 </Space>
               </div>
             </Space>
           </div>
         ),
          rowExpandable: (record) =>
            Array.isArray(record.feeStructures) &&
            record.feeStructures.length > 0,
        }
      : {};

  
   return (
     <div style={{ padding: "24px" }}>
       <div className="flex justify-between items-center mb-4">
         <h1 className="text-2xl font-bold">Make Student Payment </h1>
       </div>

       <Space direction="vertical" size="large" style={{ width: "100%" }}>
         <Card>
           {userRole !== "Student" && (
<Space style={{ marginBottom: 16 }}>
             <Select
               placeholder="Select Batch"
               style={{ width: 200 }}
               onChange={(value) => setSelectedBatch(value)}
               value={selectedBatch}
             >
               {Array.isArray(sortedBatches) &&
                 sortedBatches
                   .sort((a, b) => a.batchName.localeCompare(b.batchName))
                   .map((batch) => (
                     <Option key={batch.batchId} value={batch.batchId}>
                       {batch.batchName}
                     </Option>
                   ))}
             </Select>
           </Space>)}
           <Space style={{ marginBottom: 16 }}>
             <Select
               placeholder="Acc Year & Term"
               loading={loading}
               value={selectedTerm.termId}
               onChange={handleTermChange}
             >
               {Array.isArray(terms) &&
                 terms.map((term) => (
                   <Option key={term.termId} value={term.termId}>
                     {term.name}-{term.academicYear}
                   </Option>
                 ))}
             </Select>
           </Space>
         <Table
    columns={tableColumns}
  dataSource={finalData}
  loading={loading}
  pagination={pagination}
  onChange={handleTableChange}
  rowKey={(record) => record.studentId}
  scroll={{ x: "max-content" }}
  {...expandable}
 />
         </Card>
       </Space>
     </div>
   );
};

export default CreatePayment;
